import React from 'react';

export interface MessageAvatarProps {
  src: string;
  alt: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Avatar component for messages.
 * Displays user or assistant avatar with consistent sizing.
 */
export const MessageAvatar = React.forwardRef<
  HTMLImageElement,
  MessageAvatarProps
>(({ src, alt, className = '', size = 'md' }, ref) => {
  const avatarClass = [
    'message-avatar',
    `message-avatar--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      className={avatarClass}
      loading="lazy"
      decoding="async"
    />
  );
});

MessageAvatar.displayName = 'MessageAvatar';
